/*
 * Dovie Home — motion layer driver
 *
 * On load: hero headline/subtext/CTA blur into focus (staggered), hero image
 * settles from a slight zoom. On scroll: custom sections that Dawn's own
 * reveal-on-scroll doesn't cover fade up as they enter the viewport.
 * No-ops entirely under prefers-reduced-motion.
 */
(() => {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  const start = () => {
    // —— Hero: Blur Text on load ——
    const banner = document.querySelector('.banner');
    if (banner) {
      const pieces = banner.querySelectorAll(
        '.banner__heading, .banner__text, .banner__buttons'
      );
      pieces.forEach((el, i) => {
        el.classList.add('dovie-blur-in');
        el.style.setProperty('--dovie-delay', `${120 + i * 160}ms`);
      });
      const media = banner.querySelector('.banner__media');
      if (media) media.classList.add('dovie-kenburns');

      requestAnimationFrame(() =>
        requestAnimationFrame(() => {
          pieces.forEach((el) => el.classList.add('dovie-in'));
          if (media) media.classList.add('dovie-in');
        })
      );
    }

    // —— Custom sections: Fade Content on scroll ——
    // Only elements Dawn's reveal-on-scroll doesn't already animate.
    const targets = [];
    document
      .querySelectorAll(
        '.dovie-editorial-band, .dovie-whats-included, .dovie-trust'
      )
      .forEach((el) => {
        if (!el.closest('.scroll-trigger')) targets.push(el);
      });

    // Editorial band: stagger its direct text/media children instead of
    // popping the whole band at once.
    const expanded = [];
    targets.forEach((el) => {
      if (el.classList.contains('dovie-editorial-band')) {
        const kids = el.querySelectorAll(
          '.dovie-editorial-band__heading, .dovie-editorial-band__text, .dovie-text-link'
        );
        if (kids.length) {
          kids.forEach((kid, i) => {
            kid.style.setProperty('--dovie-delay', `${i * 130}ms`);
            expanded.push(kid);
          });
          return;
        }
      }
      expanded.push(el);
    });

    if (!expanded.length) return;
    expanded.forEach((el) => el.classList.add('dovie-reveal'));

    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('dovie-in');
          io.unobserve(entry.target);
        });
      },
      { rootMargin: '0px 0px -8% 0px', threshold: 0.15 }
    );
    expanded.forEach((el) => io.observe(el));
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
